import { render, staticRenderFns } from "./experimente-gratis.vue?vue&type=template&id=bd326858&"
import script from "./experimente-gratis.vue?vue&type=script&lang=js&"
export * from "./experimente-gratis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports